import Column from '@components/column'
import React, { Fragment, useState } from 'react'
import ReportResponseForm from './form'
import ReportResponseList from './lists'

const ReportResponse = () => {
  const [selectedReason, setSelectedReason] = useState(null)

  return (
    <Fragment>
      <Column>
        <ReportResponseForm
          selectedReason={selectedReason}
          setSelectedReason={setSelectedReason}
        />
        <ReportResponseList onEdit={(item) => setSelectedReason(item)} />
      </Column>
    </Fragment>
  )
}

export default ReportResponse
